module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/backup-campaign-cta-93820b6688133b877b88fc0af688e661.jpg";